import {DOCUMENT} from '@angular/common';
import {ChangeDetectionStrategy, Component, Signal, inject, signal} from '@angular/core';
import {RouterOutlet} from '@angular/router';

import {Sidebar} from '../components/sidebar';

const PINNED_STORAGE_KEY = 'mydeals_sidebar_pinned';

@Component({
  selector: 'crm-main-layout',
  imports: [RouterOutlet, Sidebar],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainLayout {
  private readonly document = inject(DOCUMENT);

  private readonly _isPinned = signal<boolean>(this.readPinned());
  readonly isPinned: Signal<boolean> = this._isPinned.asReadonly();

  togglePin(): void {
    const next = !this._isPinned();
    this._isPinned.set(next);
    this.persistPinned(next);
  }

  private readPinned(): boolean {
    return this.document.defaultView?.localStorage.getItem(PINNED_STORAGE_KEY) === 'true';
  }

  private persistPinned(value: boolean): void {
    this.document.defaultView?.localStorage.setItem(PINNED_STORAGE_KEY, String(value));
  }
}
